import { Box, InputLabel, Slider } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

const ScaleSlider = ({ scale, setScaleSlider, setScale }) => {
  const { t } = useTranslation();

  return (
    <Box id="scale" px={1}>
      <InputLabel shrink>{t("/editor.gui.scale")}</InputLabel>
      <Slider
        min={0.1}
        max={2}
        step={0.1}
        value={scale}
        marks
        onChangeCommitted={(e, v) => setScale(v)}
        onChange={(e, v) => setScaleSlider(v)}
        valueLabelDisplay="auto"
      />
    </Box>
  );
};

export default ScaleSlider; 